import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';

export const Header = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
  border: none;
  background: transparent;
  border-radius: 0;
  position: relative;

  &:focus {
    outline: none;
  }

  &:focus-visible::before {
    content: '';
    position: absolute;
    inset: 0px;
    border: 2px solid ${uiToken.color.border.glassActive};
    border-radius: 10px;
    pointer-events: none;
  }
`;

export const Arrow = styled.span<{ isOpen: boolean }>`
  transform: rotate(${(props) => (props.isOpen ? '0deg' : '-180deg')});
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const Body = styled.div<{ isOpen: boolean }>`
  max-height: ${({ isOpen }) => (isOpen ? '500px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const Content = styled.div<{ isOpen: boolean }>`
  padding: ${({ isOpen }) => (isOpen ? '12px 16px' : '0 16px')};
  color: ${uiToken.color.text.white75};
  transition: padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Root = styled.div<{ isOpen: boolean }>`
  position: relative;
`;
